const T = { bg: "#FFFFFF", border: "#DADFEA", iconBg: "#EEF1F7", text: "#0F1230" };

export const MACROS = [
  { id: "casa", label: "Per la casa/lavoro", icon: "Home", cats: ["casa"], tint: T },
  { id: "mezzi", label: "Per i mezzi", icon: "Car", cats: ["auto_moto"], tint: T },
  { id: "persona", label: "Per la persona", icon: "User", cats: ["servizi_persona"], tint: T },
  { id: "professionisti", label: "Cerco professionisti", icon: "Briefcase", cats: ["tecnici"], tint: T },
  { id: "educazione", label: "Famiglia e scuola", icon: "GraduationCap", cats: ["babysitter"], tint: T },
  { id: "animali", label: "Animali", icon: "PawPrint", cats: ["animali"], tint: T },
  { id: "eventi", label: "Eventi e feste", icon: "PartyPopper", cats: ["eventi"], tint: T },
  { id: "lavoretti", label: "Lavoretti e disponibilità", icon: "Hand", cats: ["lavoretti"], tint: T },
  { id: "altro", label: "Altro", icon: "LayoutGrid", cats: ["varie"], tint: T, examples: "Sartoria, lavanderia, calzolaio, corsi" },
];
